// extracted by mini-css-extract-plugin
module.exports = {"container":"Animation_container__E8_ME","animContainer":"Animation_animContainer__2yFD6","animation":"Animation_animation__3LfQt","zoomWindow":"Animation_zoomWindow__1dUqS"};